import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import SideBar from '../../components/SideBar/SideBar';
import TopNav from '../../components/TopNav/TopNav';
import api from '../../services/api';

// Who opened a given manual push. Reached by clicking the "Opened" count on
// the Manual Pushes table. group_key is passed as a query param.
const PushOpens = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const groupKey = params.get('group_key');
  const title = params.get('title') || 'this push';

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const res = await api.get('/push-notification-admin/campaign-openers', {
          params: { group_key: groupKey },
        });
        if (!cancelled) setUsers(res.data.data || []);
      } catch (e) {
        console.error('Error fetching push openers:', e);
        if (!cancelled) setUsers([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [groupKey]);

  const initials = (name) =>
    (name || '?').split(' ').map((w) => w[0]).filter(Boolean).slice(0, 2).join('').toUpperCase();
  const fmt = (d) =>
    d ? new Date(d).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : '';

  return (
    <main>
      <TopNav />
      <div className="main-container">
        <SideBar />
        <article className="page-content">
          <section style={{ width: '100%', maxWidth: 1400, padding: '8px 24px 40px', boxSizing: 'border-box' }}>
            <button
              onClick={() => navigate(-1)}
              style={{ background: 'transparent', border: '1px solid rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.7)', borderRadius: 8, padding: '6px 12px', cursor: 'pointer', marginBottom: 16, fontSize: 13 }}
            >
              ← Back
            </button>
            <h1 className="page-title" style={{ margin: '0 0 4px' }}>
              {loading ? 'Opened by…' : `Opened by ${users.length}`}
            </h1>
            <p style={{ color: 'rgba(255,255,255,0.5)', margin: '0 0 20px', fontSize: 14 }}>"{title}"</p>

            {loading ? (
              <p style={{ color: 'rgba(255,255,255,0.4)' }}>Loading…</p>
            ) : users.length === 0 ? (
              <p style={{ color: 'rgba(255,255,255,0.4)' }}>No opens recorded for this push.</p>
            ) : (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 12 }}>
                {users.map((u) => (
                  <div
                    key={u.id}
                    onClick={() => navigate(`/users/${u.id}`)}
                    style={{ display: 'flex', alignItems: 'center', gap: 12, background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 12, padding: '10px 12px', cursor: 'pointer' }}
                  >
                    {u.photo ? (
                      <img src={u.photo} alt={u.name} style={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
                    ) : (
                      <div style={{ width: 40, height: 40, borderRadius: '50%', background: 'rgba(124,92,255,0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 600, color: '#fff', flexShrink: 0 }}>
                        {initials(u.name)}
                      </div>
                    )}
                    <div style={{ overflow: 'hidden' }}>
                      <div style={{ fontWeight: 600, fontSize: 14, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{u.name}</div>
                      {u.opened_at && <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)' }}>{fmt(u.opened_at)}</div>}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </section>
        </article>
      </div>
    </main>
  );
};

export default PushOpens;
